import React from 'react';
import Localize from 'react-intl-universal';

import EventIcon from '@mui/icons-material/Event';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import ResetPassword from '@pages/MyProfile/components/ResetPassword/ResetPassword';

const StyledBox = styled(Box)(({ theme }) => ({
  minHeight: '15rem',
  backgroundColor: theme.palette.common.white,
  border: '1px solid',
  borderColor: theme.palette.booking.borderBox,
  padding: '1rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
}));

const StyledHeader = styled(Typography)(() => ({
  fontWeight: '700',
  fontSize: '16px',
  paddingTop: '2rem'
}));

const StyledSubHeader = styled(Typography)(({ theme }) => ({
  fontWeight: '400',
  fontSize: '14px',
  color: theme.palette.booking.lightSubHeader
}));

const StyledButton = styled(Button)(({ theme }) => ({
  fontWeight: '500',
  fontSize: '16px',
  textTransform: 'none',

  [theme.breakpoints.up('xl')]: {
    height: '2rem'
  }
}));

const GeneralInfo = () => {
  return (
    <>
      <StyledBox>
        <StyledHeader>Mr Tobias Rothley</StyledHeader>
        <StyledSubHeader>Future Marketing Architect</StyledSubHeader>
        <Avatar src='/broken-image.jpg' sx={{ width: 56, height: 56, mt: 2 }} />
        <Box sx={{ display: 'flex', mt: 1 }}>
          <StyledButton variant='text'>{Localize.get('Booking.changePhoto')}</StyledButton>
          <Divider orientation='vertical' flexItem />
          <StyledButton variant='text' sx={{ color: 'gray' }}>
            {Localize.get('Booking.removePhoto')}
          </StyledButton>
        </Box>
        <StyledSubHeader sx={{ mt: 1, mb: 3 }}>
          {Localize.get('Booking.fileUpTo10')}
        </StyledSubHeader>
        <ResetPassword />
        <Divider sx={{ mt: 1, mb: 2 }} flexItem />
        <Box sx={{ minWidth: '8rem' }}>
          <Box sx={{ display: 'flex' }}>
            <EventIcon color='disabled' sx={{ mr: 1, mb: 1 }} /> 4 {Localize.get('HomePage.events')}
          </Box>
          <Box sx={{ display: 'flex' }}>
            <EventIcon color='disabled' sx={{ mr: 1 }} /> 0 {Localize.get('TeamArea.certificates')}
          </Box>
        </Box>
      </StyledBox>
    </>
  );
};
export default GeneralInfo;
